import { $$ } from '../lib/dom.js';
import { reduceMotion, supportsViewTimeline } from '../lib/env.js';

/* Reveal al hacer scroll.
   En navegadores con scroll-driven animations lo resuelve el CSS.
   Acá sólo cubrimos el fallback (Firefox, Safari). */
export function initReveal() {
  if (supportsViewTimeline || reduceMotion) return;

  const items = $$('[data-reveal]');
  if (!items.length) return;

  if (!('IntersectionObserver' in window)) {
    items.forEach((el) => el.classList.add('is-revealed'));
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.05 }
  );

  items.forEach((el) => io.observe(el));
}
